// #586: Lieblings-Vorlagen je Nutzer (dokument_vorlagen_favoriten, RLS: nur eigene).
import { supabase } from '../supabase/client';

export async function ladeFavoriten(): Promise<Set<string>> {
  const { data, error } = await supabase.from('dokument_vorlagen_favoriten').select('vorlage_id');
  if (error) return new Set(); // Tabelle noch nicht da (Migration) → keine Favoriten
  return new Set((data ?? []).map((z) => z.vorlage_id as string));
}

export async function setzeFavorit(vorlageId: string, an: boolean): Promise<void> {
  const { error } = an
    ? await supabase.from('dokument_vorlagen_favoriten').upsert({ vorlage_id: vorlageId }, { onConflict: 'profile_id,vorlage_id' })
    : await supabase.from('dokument_vorlagen_favoriten').delete().eq('vorlage_id', vorlageId);
  if (error) throw error;
}

/** Felder ab Etappe 2/3/4: undefined = Spalte fehlt noch (Migration) → beim Speichern weglassen. */
export interface VorlagenExtras {
  zielgruppe: string | null; immer_post: boolean; begleittext: string; briefkopf_id?: string | null;
  schriftform?: boolean; einschreiben?: string | null;
  wiedervorlage_tage?: number | null; vorgangsart_id?: string | null;
}

/** Spaltenstufen je Etappe – fehlt eine Spalte (Migration), die nächstkleinere Stufe. */
export const VORLAGEN_SPALTEN = [
  'zielgruppe, immer_post, begleittext, briefkopf_id, schriftform, einschreiben, wiedervorlage_tage, vorgangsart_id',
  'zielgruppe, immer_post, begleittext, briefkopf_id, schriftform, einschreiben',
  'zielgruppe, immer_post, begleittext, briefkopf_id',
  'zielgruppe, immer_post, begleittext',
];

/** Zusatzfelder einer Vorlage – null, wenn die Spalten (Migration) noch fehlen. */
export async function ladeVorlagenExtras(vorlageId: string | null): Promise<VorlagenExtras | null> {
  for (const spalten of VORLAGEN_SPALTEN) {
    const q = supabase.from('dokument_vorlagen').select(spalten);
    const { data, error } = vorlageId ? await q.eq('id', vorlageId).maybeSingle() : await q.limit(1).maybeSingle();
    if (error) continue;
    const z = (vorlageId ? data : null) as Partial<VorlagenExtras> | null;
    const hat = (s: string) => spalten.includes(s);
    return {
      zielgruppe: z?.zielgruppe ?? null, immer_post: z?.immer_post === true, begleittext: z?.begleittext ?? '',
      ...(hat('briefkopf_id') ? { briefkopf_id: z?.briefkopf_id ?? null } : {}),
      ...(hat('schriftform') ? { schriftform: z?.schriftform === true, einschreiben: z?.einschreiben ?? null } : {}),
      ...(hat('wiedervorlage_tage') ? { wiedervorlage_tage: z?.wiedervorlage_tage ?? null, vorgangsart_id: z?.vorgangsart_id ?? null } : {}),
    };
  }
  return null;
}
